import Joi from 'joi';
import deviceVideoSchema from './videoDataSchema ';
const offerCardsBlockSchema = Joi.object({
  type: Joi.string().valid('offerCardsBlock', 'newsBlock').required(),
  code: Joi.string().allow('', null),
  title: Joi.string().allow('', null),
  titleLink: Joi.string().allow('', null),
  columns: Joi.number().valid(2, 3, 4, 6).allow(null),
  mobileColumns: Joi.number().valid(1, 2).allow(null),
  showCardArrows: Joi.boolean().allow(null),
  cardVariant: Joi.string().valid('default', 'story').allow(null),
  backgroundColor: Joi.string().allow('', null),
  mixBlendMode: Joi.boolean().optional(),
  cards: Joi.array().items(Joi.object({
    id: Joi.string().required(),
    title: Joi.string().required(),
    subtitle: Joi.string().allow('', null),
    href: Joi.string().required(),
    target: Joi.string().allow('', null).optional(),
    image: Joi.string().allow('', null),
    video: deviceVideoSchema.allow(null).optional(),
    brandLogo: Joi.string().allow('', null),
    labelType: Joi.string().valid('new', 'promotion', 'bestseller').allow(null)
  }).unknown(true)).required()
}).unknown(true);
export default offerCardsBlockSchema;